import Block from "quill/blots/block";
import Quill from "quill";

// Класс для разделительной линии
class LineBlotCustom extends Block {
    static blotName = 'separator';
    static tagName = 'hr';
    static className = 'ql-separator';

    static create() {
        const node = super.create() as HTMLElement;
        node.classList.add(LineBlotCustom.className);

        // Добавляем кастомные стили для линии
        node.style.border = 'none';
        node.style.borderTop = '1px solid #ccc';
        node.style.margin = '16px 0';
        node.style.width = '100%';

        return node;
    }

    static value() {
        return {};
    }

    length() {
        return 1;
    }

    formats() {
        return {};
    }
}

Quill.register(LineBlotCustom);

export default LineBlotCustom;